import { LngLat } from 'mapbox-gl';
import { computed } from 'mobx';
import { observer } from 'mobx-react-lite';
import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSaleCompStore } from '../..';
import useCircleWithRadius from '../../hooks/useCircleWithRadius';
import useCircleWithRadiusOnMap from '../../hooks/useCircleWithRadiusOnMap';
import useProperty from '../../hooks/useProperty';
import useSaleCompsWithFocusArea from '../../hooks/useSaleCompsWithFocusArea';
import useSaleCompsWithGlobalFilters from '../../hooks/useSaleCompsWithGlobalFilters';
import { GeoCoordinate } from '../../interfaces/GeoCoordinate';
import { IDetailsTabProps } from "../../interfaces/IDetailsTabProps";
import { formatNumber } from '../../utils/utils';
import RadiusDropdown from '../RadiusDropdown';
import SaleCompsGrid from '../saleComps/SaleCompsGrid';

function PropertyDetailsSaleCompsTab({ visible, setEntityCount }: IDetailsTabProps) {
    const { longitude, latitude } = useParams();
    const saleCompStore = useSaleCompStore();
    const coordinates = useMemo(() => new LngLat(Number(longitude), Number(latitude)), [longitude, latitude]);
    const geoCoordinates = useMemo(() => new GeoCoordinate(coordinates.lat, coordinates.lng), [coordinates]);
    const property = useProperty(coordinates).property!;
    const [radius, setRadius] = useState(5);
    const circle = useCircleWithRadius(property.centerPoint, radius)!;
    useCircleWithRadiusOnMap(geoCoordinates, radius, visible, "PropertyDetailsSaleCompsTab");
    const saleComps = useSaleCompsWithFocusArea(useSaleCompsWithGlobalFilters(
        useMemo(() => computed(() => saleCompStore.saleComps.filter(sc => circle.isPointInside(sc.centerPoint))), [circle]).get()
    ));

    useEffect(() => setEntityCount(saleComps.length), [saleComps]);

    if (!visible)
        return null;

    return (
        <SaleCompsGrid
            saleComps={saleComps}
            additionalHeaders={[{
                titleStrings: ["DISTANCE"],
                getValue: item => circle!.getDistanceFromCenter(item.centerPoint),
                getLabel: item => {
                    const distance = circle!.getDistanceFromCenter(item.centerPoint);
                    return distance ? formatNumber(distance) : "";
                }
            }]}
            radiusDropdown={<RadiusDropdown value={radius} onChange={setRadius} />}
        />
    );
}

export default observer(PropertyDetailsSaleCompsTab);